


































import { Vue, Watch } from 'vue-property-decorator'
import Component from 'vue-class-component'
import FormCard from '@/modules/login/components/common/FormCard.vue'
import SubmitButton from '@/modules/login/components/common/SubmitButton.vue'
import LoginStore from '@/modules/login/stores/LoginStore'
import PasswordField from '@/modules/login/components/common/PasswordField.vue'
import UserAvatar from '@/modules/login/components/common/UserAvatar.vue'

@Component({
  components: {
    PasswordField,
    SubmitButton,
    FormCard,
    UserAvatar,
  },
})
export default class PasswordForm extends Vue {
  password: string = ''
  isPending: boolean = false

  async login() {
    this.isPending = true
    const url = await LoginStore.login(this.password)
    this.isPending = false

    if (url) {
      location.assign(url)
    }
  }

  get hasErrors() {
    return !!LoginStore.errorMessage
  }

  get currentUser() {
    return LoginStore.currentUser
  }

  get title(): string {
    return `${
      this.currentUser ? `Привет ${this.currentUser.firstName}. ` : ''
    }Введите пароль`
  }

  showPhoneForm() {
    LoginStore.setAuthMethod(null)
  }

  @Watch('password')
  clearErrors() {
    LoginStore.setErrors({})
  }
}
